// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
export function applyDisplayName<T>(component: T, displayName: string): void {
  (component as any).displayName = displayName;
}



// WEBPACK FOOTER //
// /Volumes/src/internal/utils/apply-display-name.ts